import { useMemo, useState } from "react";
import { DataGrid, type DataGridColumn } from "@/components/data-grid";
import { ListPage } from "@/archetypes/ListPage";

interface Row { id: number; a: string; b: number; c: string; }
const ALL_ROWS: Row[] = Array.from({ length: 1000 }, (_, i) => ({
  id: i, a: `name-${i}`, b: i * 7, c: i % 2 === 0 ? "even" : "odd",
}));
const COLS: DataGridColumn<Row>[] = [
  { id: "id", header: "ID", accessor: (r) => r.id, width: "80px" },
  { id: "a", header: "Name", accessor: (r) => r.a, sortable: true },
  { id: "b", header: "B", accessor: (r) => r.b, align: "right" },
  { id: "c", header: "C", accessor: (r) => r.c },
];

export function PerfDataGridPage() {
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = 50;
  const slice = useMemo(
    () => ALL_ROWS.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize),
    [pageIndex],
  );
  return (
    <ListPage title="Perf grid">
      <div data-testid="grid">
        <DataGrid
          rows={slice}
          columns={COLS}
          rowKey={(r) => r.id}
          totalRows={ALL_ROWS.length}
          pageIndex={pageIndex}
          pageSize={pageSize}
          onPageChange={setPageIndex}
        />
      </div>
    </ListPage>
  );
}
